import { SPOTLIGHT_TARGETS } from "../spotlightTargets";
import { SPOTLIGHT_EVENTS } from "../spotlightEventNames";
import { COMPLETE_CHAPTER } from "../tutorialEngine";

const hubIntroductionChapter = {
	id: "hub-introduction",
	title: "Hub Introduction",
	route: "Hub",
	isEligible: ({ userData }) => userData?.accountType === "Graduate",
	next: () => "announcement",
	steps: [
		{
			id: "hub-welcome",
			target: SPOTLIGHT_TARGETS.HUB_PAGE,
			placement: "center",
			title: "Your profile is complete!",
			body: "Nice work. This is your Hub, the starting point for the rest of your graduation experience. Let's take a quick tour of where everything lives.",
			actionLabel: "Show me around",
		},
		{
			id: "hub-my-profile",
			target: SPOTLIGHT_TARGETS.HUB_MY_PROFILE,
			title: "My Profile",
			body: "This is where you manage your profile and account information. It's the page you just completed, so you can always come back to update your details.",
		},
		{
			id: "hub-my-announcement-intro",
			target: SPOTLIGHT_TARGETS.HUB_MY_ANNOUNCEMENT,
			title: "My Announcement",
			body: "Build and customize your graduation announcement and events page here, the page your friends and family will visit.",
		},
		{
			id: "hub-registry",
			target: SPOTLIGHT_TARGETS.HUB_REGISTRY,
			title: "Registry",
			body: "This is where you build your gift registry and manage your Graduation Fund.",
		},
		{
			id: "hub-dashboard",
			target: SPOTLIGHT_TARGETS.HUB_DASHBOARD,
			skipIfTargetMissing: true,
			title: "Dashboard",
			body: "Your dashboard shows registry statistics, your account information, and analytics, so you can see how your page is doing.",
		},
		{
			id: "hub-my-announcement",
			target: SPOTLIGHT_TARGETS.HUB_MY_ANNOUNCEMENT,
			interactive: true,
			title: "My Announcement",
			body: "Let's set up your announcement next.",
			instruction: "Click My Announcement to continue",
			waitFor: [
				{ event: SPOTLIGHT_EVENTS.HUB_ANNOUNCEMENT_OPENED },
				// Hand the Hub back to the user if MyTassel asks to create the page first.
				{ event: SPOTLIGHT_EVENTS.HUB_ANNOUNCEMENT_PROMPTED, goto: COMPLETE_CHAPTER },
			],
		},
	],
};

export default hubIntroductionChapter;
